<template>
    <div class="col-md-12 px-0 py-0">
        <div class="col-md-12 text-right text-success">
            <span style="font-size: 20px">Tips video</span>
        </div>
        <form action="" method="post" class="form-horizontal mt-5">
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Titulo</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="title"
                        class="form-control"
                        placeholder="Titulo"
                    />
                    <span v-if="allerrors.title" :class="['show-error']">{{
                        allerrors.title[0]
                    }}</span>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Indicación</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="indication"
                        class="form-control"
                        placeholder="Indicación"
                    />
                    <span v-if="allerrors.indication" :class="['show-error']">{{
                        allerrors.indication[0]
                    }}</span>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Resumen</label
                >
                <div class="col-md-9">
                    <textarea
                        name="summary"
                        v-model="summary"
                        style="display: none"
                    ></textarea>
                    <ckeditor
                        :editor="editor"
                        v-model="summary"
                        :config="editorConfig"
                    ></ckeditor>
                    <span v-if="allerrors.summary" :class="['show-error']">{{
                        allerrors.summary[0]
                    }}</span>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Indicación secundaria</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="summary_second"
                        class="form-control"
                        placeholder="Indicación secundaria"
                    />
                    <span
                        v-if="allerrors.summary_second"
                        :class="['show-error']"
                        >{{ allerrors.summary_second[0] }}</span
                    >
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Texto botón</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="button_text"
                        class="form-control"
                        placeholder="Texto botón"
                    />
                    <span
                        v-if="allerrors.button_text"
                        :class="['show-error']"
                        >{{ allerrors.button_text[0] }}</span
                    >
                </div>
            </div>

            <div class="modal-footer">
                <button type="button" @click="update()" class="btn btn-primary">
                    Actualizar
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            title: null,
            indication: null,
            summary: null,
            summary_second: null,
            button_text: null,
            arrayColors: [],
            allerrors: {
                title: null,
                summary: null,
                summary_second: null,
                indication: null,
                button_text: null,
            },
            editor: ClassicEditor,
            editorConfig: {
                toolbar: [
                    "bold",
                    "italic",
                    "underline",
                    "bulletedList",
                    "numberedList",
                ],
            },
        };
    },
    methods: {
        getModel() {
            let me = this;
            axios
                .get("/api/project-sections?type=tips%20video")
                .then(function (response) {
                    me.title = response.data.title;
                    me.summary = response.data.summary;
                    me.summary_second = response.data.summary_second;
                    me.indication = response.data.indication;
                    me.button_text = response.data.button_text;
                    me.clearError();
                })
                .catch(function (error) {});
        },

        update() {
            let me = this;
            if (me.validForm()) {
                axios
                    .put(
                        "/admin/project-section/tips-video/update/" +
                            me.model_id,
                        {
                            title: me.title,
                            summary: me.summary,
                            summary_second: me.summary_second,
                            indication: me.indication,
                            button_text: me.button_text,
                        }
                    )
                    .then(function (response) {
                        me.clearError();
                        me.showActionSuccess();
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },
        validForm() {
            let me = this;
            let valid = true;

            if (!me.title) {
                me.allerrors.title = ["El campo titulo es obligatorio."];
                valid = false;
            } else if (me.title.length > 50) {
                me.allerrors.title = [
                    "El campo titulo debe tener máximo 50 caraccteres",
                ];
                valid = false;
            } else {
                me.allerrors.title = [""];
            }

            if (!me.indication) {
                me.allerrors.indication = [
                    "El campo indicación es obligatorio.",
                ];
                valid = false;
            } else if (me.indication.length > 57) {
                me.allerrors.indication = [
                    "El campo indicación debe tener máximo 50 caraccteres",
                ];
                valid = false;
            } else {
                me.allerrors.indication = [""];
            }

            if (!me.summary) {
                me.allerrors.summary = ["El campo resumen es obligatorio."];
                valid = false;
            } else if (me.summary.length > 550) {
                me.allerrors.summary = [
                    "El campo resumen debe tener máximo 500 caraccteres",
                ];
                valid = false;
            } else {
                me.allerrors.summary = [""];
            }

            if (!me.summary_second) {
                me.allerrors.summary_second = [
                    "El campo indicacion secundaria es obligatorio.",
                ];
                valid = false;
            } else if (me.summary_second.length > 75) {
                me.allerrors.summary_second = [
                    "El campo indicacion secundaria debe tener máximo 70 caraccteres",
                ];
                valid = false;
            } else {
                me.allerrors.summary_second = [""];
            }

            if (!me.button_text) {
                me.allerrors.button_text = [
                    "El campo texto botón es obligatorio.",
                ];
                valid = false;
            } else if (me.button_text.length > 57) {
                me.allerrors.button_text = [
                    "El campo texto botón debe tener máximo 50 caraccteres",
                ];
                valid = false;
            } else {
                me.allerrors.button_text = [""];
            }

            return valid;
        },
        clearError() {
            let me = this;
            me.allerrors = {
                title: null,
                summary: null,
                summary_second: null,
                indication: null,
                button_text: null,
            };
        },
        showActionSuccess() {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: "Actualizacion exitosa!",
            });
        },
    },
    mounted() {
        let me = this;
        me.getModel();
    },
};
</script>
<style>
.show-error {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #f86c6b;
}
</style>
